import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { useGetStatisticsMiscellaneous } from '@nxsys/hooks/api/dashboard';
import { useNavigateWithQuery } from '@nxsys/hooks/useNavigateWithQuery';
import { useCanAccessEmployees } from '@nxsys/hooks/useCanAccessEmployees';
import { Icons } from '@nxsys/types/icons';
import { useEffect, useMemo, useState } from 'react';
import AttachmentOrderModal from './components/AttachmentOrderModal';
import EmployeeModal, {
  EmployeeModalTypeEnum,
} from './components/EmployeeModal';
import NewStarterModal from './components/NewStarterModal';

const Miscellaneous = () => {
  const navigate = useNavigateWithQuery();
  const { value, loading, run } = useGetStatisticsMiscellaneous();
  const data = useMemo(() => value?.data, [value]);
  // The cards drill into employee/subcontractor records, so a dashboard-only
  // user (no COMPANY.EMPLOYEES.LIST) sees the counts but cannot open them.
  const canAccessEmployees = useCanAccessEmployees();
  const [isOpenNewStarterModal, setIsOpenNewStarterModal] = useState(false);
  const [isOpenOnHoldModal, setIsOpenOnHoldModal] = useState(false);
  const [isOpenAttachmentOrderModal, setIsOpenAttachmentOrderModal] =
    useState(false);

  useEffect(() => {
    run();
  }, []);

  const items = [
    {
      title: data?.totalNewStarter,
      description: 'New Starter',
      icon: <Icons.IconUserPlus />,
      onClick: () => setIsOpenNewStarterModal(true),
    },
    {
      title: data?.totalP6P9,
      description: 'P6/P9',
      icon: <Icons.IconFileText />,
      onClick: () => navigate('/hmrc-update/p6-p9'),
    },
    {
      title: data?.totalStudentLoan,
      description: 'Student Loan & PG Student Loan',
      icon: <Icons.IconFileText />,
      onClick: () => navigate('/hmrc-update/student-loan'),
    },
    {
      title: data?.totalAttachmentOrder,
      description: 'Attachment Orders',
      icon: <Icons.IconFileText />,
      onClick: () => setIsOpenAttachmentOrderModal(true),
    },
    {
      title: data?.totalWorkerOnHold,
      description: 'On Hold',
      icon: <Icons.IconClipboardMinus />,
      onClick: () => setIsOpenOnHoldModal(true),
    },
  ];

  return (
    <div className="Miscellaneous">
      <AppCard className="p-[24px]" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconDocs" title="Miscellaneous" />
        </div>
        <div className="grid grid-cols-5 gap-[16px] max-sm:grid-cols-1">
          {items.map((item) => (
            <div
              key={item.title}
              className={`border border-[#CDDDD9] ${
                canAccessEmployees ? 'dashboard-hover-card' : ''
              } rounded-[8px] p-[16px]`}
              onClick={canAccessEmployees ? item.onClick : undefined}
            >
              <div className="flex items-center justify-between gap-x-[8px] mb-[34px]">
                <div className="bg-cyan-100 rounded-[8px] p-[8px]">
                  {item.icon}
                </div>
                {canAccessEmployees && <Icons.IconArrowRight />}
              </div>
              <div className="text-[22px] font-bold mb-[8px]">{item.title}</div>
              <div className="text-[14px] font-bold">{item.description}</div>
            </div>
          ))}
        </div>
      </AppCard>
      <NewStarterModal
        isOpen={isOpenNewStarterModal}
        toggle={() => setIsOpenNewStarterModal(false)}
      />
      <EmployeeModal
        isOpen={isOpenOnHoldModal}
        toggle={() => setIsOpenOnHoldModal(false)}
        type={EmployeeModalTypeEnum.ON_HOLD}
      />
      <AttachmentOrderModal
        isOpen={isOpenAttachmentOrderModal}
        toggle={() => setIsOpenAttachmentOrderModal(false)}
      />
    </div>
  );
};

export default Miscellaneous;
